export default "__VITE_ASSET__1cde2c46__"